export default "/images/6fd8b85b4d4d721cc10145240ca3b3ae.avif";